import(/* webpackMode: "eager" */ "/home/jenkins/workspace/prod/deploy-frontend/src/app/global-error.tsx");
